import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateUserLocaleParams {
  userId: string; // server user id
  locale: string;
}

export class UpdateUserLocaleRequest extends Request<IUpdateUserLocaleParams, IResult> {
  constructor(params: IUpdateUserLocaleParams) {
    super('updateUserLocale', params);
  }
}
